import Resource from '@/api/resources/Resource'

class PersonnelAutomaticAssignmentService extends Resource {
    async getRecommendedPathologistsForCase(laboratoryId, caseId) {
        const response = await this.axios.get(`registry/laboratories/${laboratoryId}/cases/${caseId}/recommendedPathologists`)
        return response.data
    }

    async isCasePathologistAutomaticAssignmentActive(laboratoryId) {
        const response = await this.axios.get(`registry/laboratories/${laboratoryId}/isCasePathologistAutomaticAssignmentActive`)
        return response.data
    }
}

export default new PersonnelAutomaticAssignmentService()
